// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

//IMG

const BannerVendi: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section id="bannerValuta" className="space-pt">
            <div className="container-fluid">
                <h2 className="mb-4 mb-5">{t('homePage.sellBanner.title')}</h2>
                <div className="row align-items-center">
                    <div className="col-12 col-lg-8 col-xl-7">
                        <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para1') as string }} />
                        <Link className="btn btn-primary" to="/valutazione">
                            <span>{t('homePage.sellBanner.btnText')}</span>
                        </Link>
                    </div>
                </div>
            </div>
            <img src="/assets/images/inHome/lucia.png" alt={t('homePage.sellBanner.imgAlt') as string} />
        </section>
    );
};

export default BannerVendi;